import { render } from "./LinkPhone.vue?vue&type=template&id=5077756b"
import script from "./LinkPhone.vue?vue&type=script&lang=js"
export * from "./LinkPhone.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__